import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NotificationService {
    private _event = signal<Event | null>(null);
    event = this._event.asReadonly();

    open(event: Event) {
        this._event.set(event);
    }
}
